import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { Store } from '@ngrx/store';
import { ChangeLang } from 'core/store';
import { getLocaleForLang } from 'core/utils/i18n.util';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor(
    private dateAdapter: DateAdapter<moment.Moment>,
    private store: Store
  ) { }

  changeLanguage(lang: string): void {
    this.dateAdapter.setLocale(getLocaleForLang(lang));
    this.store.dispatch(new ChangeLang(lang));
  }
}
